/**
 * Color intention that you want to used in your theme
 * @param {JsonObject} theme Theme customization object
 */

export default function themePalette(theme) {
    return {
        mode: theme?.customization?.navType,
        common: {
            black: theme.colors?.darkPaper
        },
        primary: {
            light: '#FCB413',
            main: '#FCB413',
            dark: '#FCB413',
            200: '#FCB413',
            800: '#FCB413'
        },
        secondary: {
            light: '#00214D',
            main: '#00214D',
            dark: '#00214D',
            200: '#00214D',
            800: '#00214D'
        },
        error: {
            light: '#FB0D1B',
            main: '#FB0D1B',
            dark: '#FB0D1B'
        },
        orange: {
            light: '#FC7013',
            main: '#FC7013',
            dark: '#FC7013'
        },
        warning: {
            light: theme.colors?.warningLight,
            main: theme.colors?.warningMain,
            dark: theme.colors?.warningDark
        },
        success: {
            light: theme.colors?.successLight,
            200: theme.colors?.success200,
            main: theme.colors?.successMain,
            dark: theme.colors?.successDark
        },
        grey: {
            50: theme.colors?.grey50,
            100: theme.colors?.grey100,
            500: theme.darkTextSecondary,
            600: theme.heading,
            700: theme.darkTextPrimary,
            900: theme.textDark
        },
        dark: {
            light: theme.colors?.darkTextPrimary,
            main: theme.colors?.darkLevel1,
            dark: theme.colors?.darkLevel2,
            800: theme.colors?.darkBackground,
            900: theme.colors?.darkPaper
        },
        text: {
            primary: theme.darkTextPrimary,
            secondary: theme.darkTextSecondary,
            dark: theme.textDark,
            hint: theme.colors?.grey100
        },
        white: {
            light: '#FAFAFC'
        },
        background: {
            paper: '#FAFAFC',
            default: '#FAFAFC'
        }
    };
}
